import { useEffect } from "react";
import customFetch from "../../util/config/axiosConfig";
import { toast } from "sonner";

const APP_ID = "605083631903295";
const CONFIG_ID = "603828229379398";


interface FBAuthResponse {
  code: string;
  accessToken?: string;
  userID?: string;
}

interface FBLoginResponse {
  authResponse: FBAuthResponse | null;
  status: string;
}

interface FBLoginOptions {
  config_id: string;
  response_type: string;
  override_default_response_type: boolean;
  extras: Record<string, unknown>;
}

interface WAEmbeddedSignupMessageData {
  type: string;
  event: string;
  data: {
    waba_id: string;
    phone_number_id: string;
  };
}

interface OnboardPayload {
  code: string;
  wabaId: string;
  phoneNumberId: string;
}

export default function EmbeddedSignup() {
  useEffect(() => {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: APP_ID,
        autoLogAppEvents: true,
        xfbml: true,
        version: "v25.0",
      });
    };

    (function (
      d: Document,
      s: string,
      id: string
    ) {
      if (d.getElementById(id)) return;
      const js = d.createElement(s) as HTMLScriptElement;
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      const fjs = d.getElementsByTagName(s)[0];
      fjs.parentNode?.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");

    window.addEventListener("message", receiveSessionInfo);
    return () => window.removeEventListener("message", receiveSessionInfo);
  }, []);

  const receiveSessionInfo = async (event: MessageEvent): Promise<void> => {
    if (
      event.origin !== "https://www.facebook.com" &&
      event.origin !== "https://web.facebook.com"
    )
      return;

    try {
      const parsed = JSON.parse(event.data as string) as WAEmbeddedSignupMessageData;

      if (
        parsed.type === "WA_EMBEDDED_SIGNUP" &&
        parsed.event === "FINISH" &&
        window.__fbAuthCode
      ) {
        const payload: OnboardPayload = {
          code: window.__fbAuthCode as string,
          wabaId: parsed.data.waba_id,
          phoneNumberId: parsed.data.phone_number_id,
        };

        await customFetch.get("/api/auth/callback", {
          params: {
            code: payload.code,
            wabaId: payload.wabaId,
            phoneNumberId: payload.phoneNumberId,
          },
        });
        toast.success("WhatsApp connected successfully!");
      }
    } catch (e) {
      console.error("Failed to process WhatsApp signup event:", e);
    }
  };

  const launchSignup = (): void => {
    window.FB.login(
      (response: FBLoginResponse) => {
        if (response.authResponse) {
          window.__fbAuthCode = response.authResponse.code;
        }
      },
      {
        config_id: CONFIG_ID,
        response_type: "code",
        override_default_response_type: true,
        extras: { version: "v3" },
      }
    );
  };

  return (
    <button onClick={launchSignup} className="bg-brand-blue-gradient p-5 text-white font-bold rounded-4xl">
      Connect WhatsApp Business
    </button>
  );
}
